var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7499 0H2.25011C1.01284 0 0 1.01284 0 2.25011V24.7499C0 25.9872 1.01284 27 2.25011 27H24.7499C25.9872 27 27 25.9872 27 24.7499V2.25011C27 1.01284 25.9872 0 24.7499 0ZM20.4238 22.0077C20.4238 22.0077 19.9756 23.1964 18.7431 22.6263L14.1855 18.9196L11.2631 21.7475C11.2631 21.7475 11.0346 21.9311 10.7841 21.8157C10.7841 21.8157 10.5688 21.7937 10.2988 20.8929C10.0305 19.9888 8.66396 15.2371 8.66396 15.2371L4.13978 13.6212C4.13978 13.6212 3.4452 13.3596 3.37939 12.7892C3.31155 12.2192 4.16374 11.9094 4.16374 11.9094L22.1461 4.42564C22.1461 4.42564 23.625 3.7368 23.625 4.87721L20.4238 22.0077Z",
    fill: "#0D0D0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.babda1425cc9e3a2f4a225ed907c3ae3.svg";
export { ForwardRef as ReactComponent };